import React from "react";
import {Brands} from "@core-ui/utility";
import {Icon} from "../components/Icon";
import {IconContainerProps} from "../types";

const CrossBrandSVG = (
  <svg fill="none" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.9428 13.5286l-3.6571-.4572-1.6-3.19998c-.2286-.34286-.5714-.57143-.9143-.57143-.3428 0-.8.22857-.9143.57143l-1.7143 3.19998-3.54281.5714c-.45714.1143-.68571.3429-.91429.6858-.11428.3428 0 .8.22858 1.1428l2.62852 2.5143-.5714 3.5429c-.1143.4571.1143.8.4572 1.0285.3428.2286.8.2286 1.1428.1143l3.2-1.7143 3.2 1.7143c.1143.1143.3429.1143.4572.1143.2285 0 .4571-.1143.6857-.2286.3428-.2285.4571-.6857.4571-1.0285L20 17.9857l2.6286-2.5143c.3428-.2286.3428-.6857.2285-1.1428-.2285-.4572-.5714-.6858-.9143-.8z"
      fill="#000"
    />
    <path
      clipRule="evenodd"
      d="M.114258 16.2714C.114258 7.58569 7.08569.614258 15.7714.614258 24.3428.614258 31.2 7.69997 31.2 16.2714c0 8.5714-6.9715 15.5429-15.5429 15.5429-8.57141 0-15.542842-6.8572-15.542842-15.5429zm1.942852 0c0 7.5429 6.17143 13.7143 13.71429 13.7143 7.5429 0 13.7143-6.1714 13.7143-13.7143 0-7.54286-6.1714-13.71429-13.7143-13.71429-7.54286 0-13.71429 6.17143-13.71429 13.71429z"
      fill="#000"
      fillRule="evenodd"
    />
  </svg>
);

const brandIconSVGs = {
  [Brands.Athleta]: CrossBrandSVG,
  [Brands.BananaRepublic]: CrossBrandSVG,
  [Brands.BananaRepublicFactoryStore]: CrossBrandSVG,
  [Brands.Gap]: CrossBrandSVG,
  [Brands.GapFactoryStore]: CrossBrandSVG,
  [Brands.OldNavy]: CrossBrandSVG,
  crossBrand: CrossBrandSVG,
};

export const ValueDrawerRewardsOutlineIcon = (
  props: IconContainerProps
): JSX.Element => <Icon {...props} brandIconSVGs={brandIconSVGs} />;
